export const events = {
  goToPermissions: 'Go to permissions page',
  goToPermissionsHelpCenter: 'Go to permissions help center',
  delegatePermissionsOpened: 'Delegate Permissions Page Opened',
  delegatePermissionsSelected: 'Delegate Permissions toggled',
}
